import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { get } from "utils/api";
import Bathtub from "assets/images/cartplan1.svg";

const CleaningPackage = () => {
  const location = useLocation();
  const navigator = useNavigate();
  const [CleaningCategory, setCleaningCategory] = useState([]);
  const [CleaningList, setCleaningList] = useState([]);
  const [filterCleaningList, setFilterCleaningList] = useState([]);
  const [dropdownSelected, setDropdownSelected] = useState("All Category");
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");

  const fetchCleaningCategories = async () => {
    try {
      const res = await get(
        `api/cleaning-service/get-list-for-admin/${userId}`
      );
      setCleaningCategory(res.data);
    } catch (error) {
      console.error(error);
    }
  };
  const cleaningPackages = {
    1: "Delux Cleaning Package",
    2: "Premium Cleaning Package",
    3: "Basic Cleaning Package",
  };

  const fetchCleaningList = async () => {
    try {
      const res = await get(
        `api/cleaning-service/get-list-for-admin/${userId}`
      );
      setCleaningList(res.data);
      setFilterCleaningList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDropdownSelection = (item) => {
    setDropdownSelected(item.name);
    if (item.name === "All Category") {
      setFilterCleaningList(CleaningList);
    } else {
      const filterData = CleaningList.filter(
        (data) =>
          data.cleaning_service_category_id ===
          item.cleaning_service_category_id
      );
      setFilterCleaningList(filterData);
    }
  };
  const handleViewMore = (id) => {
    navigator(`/user/Cleaning_company/Cleaning`, {
      state: { furId: id },
    });
  };

  useEffect(() => {
    fetchCleaningCategories();
    fetchCleaningList();
  }, [userId]);

  return (
    <>
      <Header title={"List of Cleaning"} />
      <div className="container btn-space">
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {dropdownSelected}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => handleDropdownSelection({ name: "All Category" })}
            >
              All Category
            </Dropdown.Item>
            {CleaningCategory.map((item, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => handleDropdownSelection(item)}
              >
                {item.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="container">
        {filterCleaningList.length > 0 ? (
          <>
            {filterCleaningList.map((item, index) => (
              <div
                className="container-fluid cleaning-package-container"
                key={index}
              >
                <div className="row">
                  <div className="col">
                    <div className="main-box mt-0">
                      <div className="content-header">
                        <h3>{item?.name.toUpperCase()}</h3>
                      </div>
                      <div className="content-middle">
                        <div className="profile-sec">
                          <img src={Bathtub} alt="" />
                        </div>
                        <div className="profile-content">
                          <ul>
                            <li>
                              <span>Name</span>
                              <>
                               {item.name}
                              </>
                            </li>
                            <li>
                              <span>Price</span>
                              <>${item?.price}</>
                            </li>
                            <li>
                              <span>Category</span>
                              {cleaningPackages[
                                item?.cleaning_service_category_id
                              ] || "Unknown Package"}
                            </li>
                            <h3>Description : </h3>
                            <br />
                            <p style={{ whiteSpace: "pre-wrap" }}>
                               { item?.description}
                            </p>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="dual-btn">
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => {
                  window.history.back();
                }}
              >
                Go Back{" "}
              </button>
            </div>
          </>
        ) : (
          <Spinner />
        )}
      </div>
    </>
  );
};

export default CleaningPackage;
